var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as seoTextFactory from '../../../classes/definitions/seoText/setText';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import seoTextSchema from '../../../schemas/seoTextSchema';
import Input from '../../UI/Input/Input';
var SeoTextForm = /** @class */ (function (_super) {
    __extends(SeoTextForm, _super);
    function SeoTextForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '-1';
        _this.messages = null;
        _this.bottomMessages = null;
        _this.state = {
            formConfig: _.cloneDeep(seoTextSchema),
            formIsValid: false,
        };
        _this.getSeoTextHome = function () {
            _this.api
                .getSeoTextHome()
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане.';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var seoText = seoTextFactory.createSeoText(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            // Set Bulgarian description
            _.set(updatedFormConfig, 'bg_description', __assign(__assign({}, updatedFormConfig.bg_description), { value: seoText.BgName, touched: true, valid: true }));
            // Set English description
            _.set(updatedFormConfig, 'en_description', __assign(__assign({}, updatedFormConfig.en_description), { value: seoText.EnName, touched: true, valid: true }));
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedSeoText = {
                bg_description: _.get(formData, 'bg_description.value', null),
                en_description: _.get(formData, 'en_description.value', null),
            };
            var actionMethod = _this.editId === '-1' ? _this.api.createSeoText : _this.api.createSeoText;
            actionMethod({ home_addition: submittedSeoText }, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.bottomMessages.show({
                    severity: 'success',
                    detail: 'Промената бе завършена успешно.',
                    life: 5000,
                });
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване.';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        return _this;
    }
    SeoTextForm.prototype.componentDidMount = function () {
        this.getSeoTextHome();
    };
    SeoTextForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) {
                        return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                    }, blur: function (event) {
                        return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                    } })));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            React.createElement(Messages, { ref: function (el) {
                    _this.bottomMessages = el;
                } }),
            actionBtns));
    };
    return SeoTextForm;
}(React.Component));
// @ts-ignore
export default withRouter(SeoTextForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/SeoText/SeoTextForm/SeoTextForm.tsx
// module id = 461
// module chunks = 0